import React from "react";
import WordRecloudChart from "../../utils/charts/d3Graphs/WordcloudChart";
import TableOrm from "./tableorm";
import TatSummary from "./TatSummary";
import uuid from "react-uuid";
import HighCharts from "../../utils/charts/HighCharts";
const OrmGraphs = ({
  single,
  style,
  defualtvalue,
  flr,
  resolution,
  tat,
  tabData,
  allData,
}) => {
  const style_new = {
    width: "100%",
    height: "550px",
  };

  if (single?.graph_type === "line" || single?.graph_type === "number-line") {
    return (
      <HighCharts
        dashboard={true}
        single={single?.data}
        style={style}
        group={true}
        graph_type={single?.graph_type}
        ormGraphs={true}
        yaxis={single?.y_label}
        xaxis={single?.x_label}
        y_range={single?.y_range}
        id={allData?.widget_id}
        type="line"
        stacked={true}
      />
    );
  } else if (single?.graph_type === "bar" && !single?.stacked) {
    return (
      <HighCharts
        single={[single?.data?.bar]}
        style={style}
        ormGraphs={true}
        yaxis={single?.y_label}
        xaxis={single?.x_label}
        stacked={single?.stacked}
        id={allData?.widget_id}
        type="bar"
      />
    );
  } else if (single?.graph_type === "group_bar") {
    return (
      <HighCharts
        dashboard={true}
        single={single?.data?.bar ? [single?.data?.bar] : single?.data}
        style={style}
        group={true}
        ormGraphs={true}
        yaxis={single?.y_label}
        xaxis={single?.x_label}
        widget_id={single?.widget_id}
        id={allData?.widget_id}
        type="bar"
        stacked={true}
      />
    );
  } else if (single?.graph_type === "bar" && single?.stacked === true) {
    return (
      <HighCharts
        dashboard={true}
        single={single?.data?.bar}
        style={style}
        ormGraphs={true}
        yaxis={single?.y_label}
        xaxis={single?.x_label}
        id={allData?.widget_id}
        type="bar"
        stacked={true}
      />
    );
  } else if (single?.graph_type === "combination") {
    return (
      <HighCharts
        dashboard={true}
        single={single?.data?.combination}
        style={style}
        ormGraphs={true}
        yaxis={single?.y_label}
        xaxis={single?.x_label}
        id={allData?.widget_id}
        type="combination"
        stacked={true}
      />
    );
  } else if (single?.graph_type === "number-bar") {
    return (
      <div>
        <HighCharts
          dashboard={true}
          single={single?.data}
          style={style}
          ormGraphs={true}
          yaxis={single?.y_label}
          xaxis={single?.x_label}
          stacked={single?.stacked}
          id={allData?.widget_id}
          type="bar"
        />
      </div>
    );
  } else if (single?.graph_type === "grid-pie") {
    return (
      <div className="row">
        <div className="col-12 col-md-5">
          <HighCharts
            dashboard={true}
            single={single?.data?.pie[0]?.data}
            style={style}
            group={true}
            graph_type={single?.graph_type}
            ormGraphs={true}
            yaxis={single?.y_label}
            xaxis={single?.x_label}
            y_range={single?.y_range}
            id={allData?.widget_id}
            type="donut"
          />
        </div>
        <div className="col-12 col-md-7">
          <TableOrm
            flr={flr}
            resolution={resolution}
            tabData={tabData}
            graphType="grid-pie"
            widget_id={single?.widget_id}
            single={single?.data?.grid}
          />
        </div>
      </div>
    );
  } else if (single?.graph_type === "pie") {
    return (
      <div>
        <HighCharts
          dashboard={true}
          single={single?.data}
          style={style}
          group={true}
          graph_type={single?.graph_type}
          ormGraphs={true}
          yaxis={single?.y_label}
          xaxis={single?.x_label}
          y_range={single?.y_range}
          id={allData?.widget_id}
          type="pie"
        />
      </div>
    );
  } else if (single?.graph_type === "heatmap") {
    return (
      <div>
        {/* <HeatChart single={[single?.data[0]]} style={style} /> */}
      </div>
    );
  } else if (single?.graph_type === "wordcloud") {
    return (
      <div>
        <WordRecloudChart
          single={[single?.data[0]]}
          id={uuid()}
          style={style}
        />
      </div>
    );
  } else if (single?.graph_type === "grid") {
    return (
      <TableOrm
        flr={flr}
        resolution={resolution}
        widget_id={single?.widget_id}
        single={single?.data}
      />
    );
  } else if (single?.graph_type === "sunburst") {
    return (
      <div>
        {/* <SunburstChart single={[single?.data]} style={style} /> */}
      </div>
    );
  } else if (single?.graph_type === "number-tree") {
    return (
      <div className="p-15">
        <TatSummary
          tat={tat}
          defualtvalue={defualtvalue}
          single={single?.data}
        />
      </div>
    );
  } else return <></>;
};

export default OrmGraphs;
